

import axios from '@/api/config';

const appConfigure = {
  // 保存模块内容
  addAppSchoolPageList(data){
    return axios.post(`${process.env.BASE_URL}/appSchoolPage/addAppSchoolPageList`, data);
  },
  //获取模块内容
  getAppSchoolPageTemplate(data) {
        return axios.get(`${process.env.BASE_URL}/appSchoolPage/getAppSchoolPageByTemplateId/${data}`, );
    },
    //模板列表
    appList(data) {
      return axios.post(`${process.env.BASE_URL}/appSchoolPageTemplate/pageList`, data);
  },
  // 获取资讯列表
  getInformationList(data){
    return axios.get(`${process.env.BASE_URL}/information/getInformationPageList`, { params: data });
},
// 创建模块
  addAppSchoolPageTemplate(data){
    return axios.post(`${process.env.BASE_URL}/appSchoolPageTemplate/addAppSchoolPageTemplate`, data);
  },

  // 修改模板信息
  updateAppSchoolPageTemplate(data){
    return axios.post(`${process.env.BASE_URL}/appSchoolPageTemplate/updateAppSchoolPageTemplate`, data);
  },
  // 使用模板
  useAppSchoolPageTemplate(data){
    return axios.post(`${process.env.BASE_URL}/appSchoolPageTemplate/useAppSchoolPageTemplate`, data);
  },
    // addAttachmentPhoto(data) {
    //     return axios.post(`${process.env.BASE_URL}/attachment/addAttachmentPhoto`, data);
    // },
    // deleteAttachment(data) {
    //     return axios.delete(`${process.env.BASE_URL}/attachment/deleteAttachment`, {data:data});
    // },
    // getAttachmentList(data) {
    //     return axios.get(`${process.env.BASE_URL}/attachment/getAttachmentList`, { params: data });
    // },
    // pageList(data) {
    //     return axios.post(`${process.env.BASE_URL}/attachment/pageList`,  data );
    // },
}
export default appConfigure;


// WEBPACK FOOTER //
// ./src/api/appConfigure.js